import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { List, ListItem, ListItemText } from '@mui/material';

import { legendLabels } from 'src/components/dashboard/DashboardPage/widgets/OpenCommentsWidget/index';

import { styles } from './index.styles';

const OpenCommentsLegend: FC = () => {
  const { t } = useTranslation('dashboard');

  return (
    <List
      className="OpenCommentsLegend-root"
      data-test-id="OpenCommentsLegendRoot"
      sx={styles.openCommentsLegend}
    >
      {legendLabels.map((legendLabel, index) => (
        <ListItem disablePadding key={legendLabel} sx={styles.listItem(index)}>
          <ListItemText primary={t(`OpenComments.${legendLabel}`)} />
        </ListItem>
      ))}
    </List>
  );
};

export default OpenCommentsLegend;
